(() => {
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  let opener;
  let previousOverflow;
  let quantityTimer;
  const dialog = () => document.getElementById('GiftyCartDrawer');
  const page = () => document.querySelector('[data-gf-cart-page]');
  const sections = () => ['gifty-cart-drawer', page()?.dataset.gfCartSection].filter(Boolean);
  const close = () => dialog()?.close();
  function open(trigger) {
    const modal = dialog();
    if (!modal || modal.open) return;
    opener = trigger || document.activeElement;
    previousOverflow = document.body.style.overflow;
    modal.showModal();
    document.body.style.overflow = 'hidden';
  }
  function error(message) {
    document.querySelectorAll('[data-gf-cart-error]').forEach(el => { el.textContent = message; });
  }
  function patch(html, cart) {
    const active = document.activeElement;
    const key = active?.closest('[data-gf-cart-line]')?.dataset.key;
    const increase = active?.dataset.gfCartStep;
    const parser = new DOMParser();
    for (const markup of Object.values(html || {})) {
      if (!markup) continue;
      const doc = parser.parseFromString(markup, 'text/html');
      const drawer = doc.querySelector('[data-gf-cart-drawer-content]');
      if (drawer) dialog()?.querySelector('[data-gf-cart-drawer-content]')?.replaceWith(drawer);
      const content = doc.querySelector('[data-gf-cart-page]');
      if (content) page()?.replaceWith(content);
    }
    document.querySelectorAll('[data-gf-cart-label]').forEach(el => { el.textContent = `${el.dataset.label} (${cart.item_count})`; });
    if (key) {
      const scope = dialog()?.open ? dialog() : page();
      const line = [...(scope?.querySelectorAll('[data-gf-cart-line]') || [])].find(el => el.dataset.key === key);
      (increase ? line?.querySelector(`[data-gf-cart-step="${increase}"]`) : line?.querySelector('[data-gf-cart-quantity]'))?.focus({ preventScroll: true });
      if (!line && dialog()?.open) dialog().querySelector('[data-gf-cart-close]')?.focus();
    }
    document.dispatchEvent(new CustomEvent('shopify:section:load'));
    document.dispatchEvent(new CustomEvent('cart:rendered', { detail: { cart } }));
  }
  async function refresh() {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', sections().join(','));
    const [html, cart] = await Promise.all([
      fetch(url, { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error(); return r.json(); }),
      fetch(`${root}cart.js`).then(r => { if (!r.ok) throw new Error(); return r.json(); })
    ]);
    patch(html, cart);
  }
  function enqueue(action) {
    pending = pending.catch(() => {}).then(action).catch(e => error(e.message || 'Your cart could not be updated. Please try again.'));
    return pending;
  }
  async function change(line, quantity) {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    line.setAttribute('aria-busy', 'true');
    error('');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.key, quantity, sections: sections(), sections_url: window.location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message);
      if (cart.sections && Object.values(cart.sections).every(Boolean)) patch(cart.sections, cart);
      else await refresh();
    } finally { line.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gf-cart-open]');
    if (trigger && dialog()) { event.preventDefault(); open(trigger); enqueue(refresh); return; }
    if (event.target.closest('[data-gf-cart-close]')) { close(); return; }
    if (event.target === dialog()) {
      const box = dialog().getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right) close();
    }
    const control = event.target.closest('[data-gf-cart-step],[data-gf-cart-remove]');
    if (!control) return;
    event.preventDefault();
    const line = control.closest('[data-gf-cart-line]');
    const quantity = control.hasAttribute('data-gf-cart-remove') ? 0 : Number(line.querySelector('[data-gf-cart-quantity]').value) + Number(control.dataset.gfCartStep);
    enqueue(() => change(line, quantity));
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-gf-cart-quantity]')) return;
    clearTimeout(quantityTimer);
    const field = event.target;
    quantityTimer = setTimeout(() => {
      const value = Number(field.value);
      if (field.value && Number.isInteger(value) && value >= 0 && field.isConnected) enqueue(() => change(field.closest('[data-gf-cart-line]'), value));
    }, 500);
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-gf-cart-quantity]')) return;
    clearTimeout(quantityTimer);
    const field = event.target;
    const value = Number(field.value);
    if (!field.value || !Number.isInteger(value) || value < 0) { enqueue(refresh); return; }
    enqueue(() => change(field.closest('[data-gf-cart-line]'), value));
  });
  document.addEventListener('cart:updated', event => { if (event.detail?.open) open(); enqueue(refresh); });
  document.addEventListener('cart:refresh', () => enqueue(refresh));
  document.addEventListener('DOMContentLoaded', () => {
    dialog()?.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow || '';
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
  });
})();
